var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "clearfix bord hot-atlas",
        attrs: { "data-role": "hot-pic", id: "topScrollPic" },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "focus", attrs: { id: "focus" } }, [
          _c("div", { staticClass: "scroll swiper" }, [
            _c("div", { staticClass: "widget-swiper" }, [
              _c("div", { staticClass: "scroll" }, [
                _c(
                  "div",
                  {
                    ref: "itemWrapper",
                    staticClass: "con",
                    attrs: { "data-role": "item-wrapper", "data-spm": "fspic" },
                  },
                  _vm._l(_vm.swiperData, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "pic img-do",
                        attrs: { "data-spm-type": "resource" },
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: item.path,
                              target: "_blank",
                              "data-spm-type": "content",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.preloadUrl,
                                "data-strict": "true",
                                alt: "",
                                "data-src": item.focusImg,
                              },
                            }),
                            _vm._v(" "),
                            item.hasVideo
                              ? _c("i", { staticClass: "icon icon-video" })
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "linear-box widget-txt" }, [
                          _c("em", { staticClass: "linear-bg" }),
                          _vm._v(" "),
                          _c(
                            "a",
                            { attrs: { href: item.path, target: "_blank" } },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(item.title) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    )
                  })
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bullets" },
                _vm._l(_vm.swiperData, function (i, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      class: index == 0 ? "active" : "",
                      attrs: { "data-id": index },
                      on: {
                        click: function ($event) {
                          _vm.goPage(index)
                        },
                      },
                    },
                    [
                      _c("a"),
                      _vm._v(_vm._s(index) + "\n                        "),
                    ]
                  )
                })
              ),
              _vm._v(" "),
              _c("div", { staticClass: "btns" }, [
                _c("a", {
                  staticClass: "btnl",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.goPrev },
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "btnr",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.goNext },
                }),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "clearfix hot-atlas", attrs: { "data-role": "four-pic" } },
      [
        _c(
          "div",
          {
            staticClass: "pic-group clearfix",
            attrs: { "data-spm": "pic-group", id: "bottomPicList" },
          },
          [
            _c(
              "ul",
              _vm._l(_vm.bottomPic, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: _vm.picGroupItemStyle(index),
                    staticStyle: {
                      width: "145px",
                      height: "132px",
                      float: "left",
                      "margin-bottom": "10px",
                      padding: "0",
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: item.url,
                          target: "_blank",
                          "data-spm-content": _vm.dataSpmCnt(item),
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            width: "100%",
                            height: "87px",
                            "margin-bottom": "5px",
                          },
                          attrs: {
                            "data-src": item.focus,
                            alt: "",
                            src: _vm.preloadUrl,
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "txt",
                            staticStyle: { width: "100%" },
                          },
                          [_vm._v(_vm._s(item.title))]
                        ),
                      ]
                    ),
                  ]
                )
              })
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleR" }, [
      _c("span", { staticClass: "tt" }, [_vm._v("热门精选")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }